import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { OrgProvider } from './contexts/OrgContext';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { IntlProvider } from 'react-intl';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CurrencyProvider>
    <OrgProvider>
    <IntlProvider locale="en" messages={{}}>
        <App />
    </IntlProvider>
    </OrgProvider>
    </CurrencyProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
